module.exports = __webpack_public_path__ + "img/application-empty-state.fc9df315.svg";